<div class="block-wrapper" [style.padding-top.px]="block.styles.paddingTop"
     [style.padding-bottom.px]="block.styles.paddingBottom">
  <div class="w-100"
       [style.height.px]="block.styles.height"
       [style.background-color]="block.styles.color"></div>
</div>

